import React from 'react';
import { connect } from 'react-redux';
import { fetchAdministrationCausesPrincipales } from 'store/administration/administrationActions';

import { postCausePrincipale } from 'store/administration/administrationActions';
import { deleteCausePrincipale } from 'store/administration/administrationActions';

import AdministrationCausesPrincipales from './AdministrationCausesPrincipales';
import withLoader from 'components/Shared/withLoader';

const AdministrationCausesPrincipalesWithLoader = withLoader(AdministrationCausesPrincipales);

class AdministrationCausesPrincipalesContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            addCausePrincipaleDialogOpen: false,
            deleteCausePrincipaleDialogOpen: false,
            causePrincipaleToDelete: null
        };
    }

    async componentDidMount() {
        await this.props.fetchAdministrationCausesPrincipales({ avecNbActions: true });
    }


    handleOpenAddDialog = () => {
        this.setState({
            addCausePrincipaleDialogOpen: true
        });
    };
    handleCloseAddDialog = () => {
        this.setState({
            addCausePrincipaleDialogOpen: false
        });
    };

    addCausePrincipale = async (causePrincipale) => {
        await this.props.postCausePrincipale(causePrincipale);
    };
             
    

    handleOpenDeleteDialog = (causePrincipaleId) => {        
        this.setState({
            deleteCausePrincipaleDialogOpen: true,
            causePrincipaleToDelete: this.props.causesPrincipales.find(x => x.id === causePrincipaleId)
        });
    };
    handleCloseDeleteDialog = () => {
        this.setState({
            deleteCausePrincipaleDialogOpen: false,
            causePrincipaleToDelete: null
        });
    };
    

    deleteCausePrincipale = async (causePrincipaleId) => {
        this.setState({
            deleteCausePrincipaleDialogOpen: false
        });
        await this.props.deleteCausePrincipale(causePrincipaleId);
    };

    render() {
        const { isLoading, causesPrincipales } = this.props;

        return (
            <AdministrationCausesPrincipalesWithLoader
                isLoading={isLoading}
                causesPrincipales={causesPrincipales}

                addCausePrincipaleDialogOpen={this.state.addCausePrincipaleDialogOpen}
                addCausePrincipale={this.addCausePrincipale}
                onOpenAddDialog={this.handleOpenAddDialog}
                onCloseAddDialog={this.handleCloseAddDialog}


                deleteCausePrincipaleDialogOpen={this.state.deleteCausePrincipaleDialogOpen}
                deleteCausePrincipale={this.deleteCausePrincipale}
                onOpenDeleteDialog={this.handleOpenDeleteDialog}
                onCloseDeleteDialog={this.handleCloseDeleteDialog}
                causePrincipaleToDelete={this.state.causePrincipaleToDelete}
            />
        );
    }
}

const mapStateToProps = state => ({
    isLoading: state.administration.causesPrincipales.isLoading,
    causesPrincipales: state.administration.causesPrincipales.items
});


const mapDispatchToProps = {
    fetchAdministrationCausesPrincipales,
    postCausePrincipale,
    deleteCausePrincipale
};


export default connect(mapStateToProps, mapDispatchToProps)(AdministrationCausesPrincipalesContainer);